import { useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FerramentasDeDetalhe } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Icon,
    Paper, Tooltip, Typography, useTheme,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    tableCellClasses,
    IconButton,
    Tab,
    Tabs,
    tabsClasses,
    FormControl,
    InputLabel,
    Select,
    MenuItem

} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { FranquiaService, IDetalheFranquia, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { styled } from '@mui/material/styles';
import { Loading } from "../../shered/components/loading/Loading";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { DisputaService } from "../../shered/services/api/disputa/DisputaService";
import CookieService from "../../shered/services/autenticacao/CookieService";
import imgCoroa from "../../img/coroa.png"
import imgCoroaWhite from "../../img/coroaWhite.png"

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ?
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {
                    // value === index && (
                    <Box sx={{ p: 1 }}>
                        <Grid>{children}</Grid>
                    </Box>
                    //)
                }
            </div>
            : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: UtilidadeService.isMobile() ? 10 : 14
    },
    [`&.${tableCellClasses.body}`]: {
        padding: "8px ",
        fontSize: UtilidadeService.isMobile() ? 10 : 14
    },
    [`&.${tableCellClasses.footer}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    }
}));


const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td': {
        border: 0,
        fontSize: UtilidadeService.isMobile() ? 10 : 14
    },
    '&:last-child th': {
        border: 0,
        padding: UtilidadeService.isMobile() ? "8px 5px" : "16px 10px "
    },
    '&:nth-of-type(odd):hover': {
        backgroundColor: "#fbc02d",
        fontWeight: "bold"
    },
    '&:nth-of-type(even):hover': {
        backgroundColor: "#fbc02d",
        fontWeight: "bold"
    },
}));


export const ListagemDeCopinha: React.FC = () => {
    //const theme = useTheme();
    const { themeName } = useAppThemeContext();
    const user = CookieService.get("access_user");
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const { id } = useParams<"id">();
    const [isLoading, setIsLoading] = useState(false);
    const { logout } = useAuthContext();
    //const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [voltar, setVoltar] = useState(false);
    const [valueTabRodada, setValueTabRodada] = useState(0);
    const [valoresTimeSorteio, setValoresTimeSorteio] = useState<any[]>([]);
    const [qtdRodadasEscolidas, setQtdRodadasEscolidas] = useState<number[]>([]);
    const [showRodadasTabs, setShowRodadasTabs] = useState(false);
    const [lstFranquia, setLstFranquia] = useState<ILstDrop[]>([]);
    const [minhaFranquia, setMinhaFranquia] = useState(0);
    const [parametroCrypt, setParametroCrypt] = useState("");
    //const [parametroDecrypt, setParametroDecrypt] = useState("");
    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [qtdRodadas, setQtdRodadas] = useState(0);
    const [rodadaAtual, setRodadaAtual] = useState(0);
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../../semimagemescudo.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();

    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "1");
    }, [searchParams]);


    useEffect(() => {
        setRemoveLoading(false);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        else {
            let rodada: string | undefined = "-1";
            let retornoTemporada: string | undefined = "-1";
            if (id !== undefined) {
                let dados = UtilidadeService.decrypt(id.toString());
                rodada = dados?.split("|")[0];
                retornoTemporada = dados?.split("|")[1];
                setValueTabRodada(Number(rodada));
                setVoltar(true);
            }
            setIsLoading(true);
            const fetchData = async () => {
                setIsLoading(false);
                await UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                        setCodigoTemporada(retornoTemporada !== undefined ? Number(retornoTemporada) : 0);

                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });

                await FranquiaService.getByIdLiga(Number(codigoLiga))
                    .then((result) => {
                        const lstFranquias = result.dado;
                        let minha = lstFranquias.find(f => f.codigo_Usuario === user.codUsuario);
                        setMinhaFranquia(minha != undefined ? minha?.codigo : 0)
                        let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome, descricao: f.caminho_Logo }));
                        setLstFranquia(lstFranquia);
                    }).catch((errors) => {
                        setRemoveLoading(true);
                        setShowModalMensagem(true);
                        if (errors.response != undefined) {
                            if (errors.response.data.statusHTTP === 401) {
                                setDadosModal({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                                setDadosModal({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: errors.response.data.mensagem,
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                setRedirecionar("/usuario/liga");
                                return;
                            }
                        }
                        else {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar("/usuario/liga");
                            return;
                        }
                    });

                await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const liga = result.dado;
                        setDadosLiga(liga);
                        setCodigoTemporada(retornoTemporada !== undefined ? Number(retornoTemporada) : liga.codigo_Temporada);
                        handleSelectedTemporada(retornoTemporada !== undefined ? Number(retornoTemporada) : liga.codigo_Temporada, Number(rodada), liga.quantidade_Rodada);
                        setQtdRodadas(liga.quantidade_Rodada);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar("/usuario/liga");
                        return;
                    });
            }
            fetchData();
        }
    }, [pagina, codigoLiga]);

    const handleSave = async (dados: IDetalheFranquia) => {
        setIsLoading(true);
        setIsLoading(false);
    };

    const handleSelectedTemporada = async (temporada: number, codigoRodada: number, quantidadeRodadas: number) => {
        setIsLoading(true);
        setRemoveLoading(false);
        let quantidadeRodada: number[] = [];
        await DisputaService.getCalendarioRodadasCopinhaPorTemporada(Number(codigoLiga), temporada)
            .then((result) => {
                quantidadeRodada = result.dado;
                setQtdRodadasEscolidas(result.dado);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });
        await DisputaService.getCalendarioCopinhaPorCodigoLigaTemporada(Number(codigoLiga), temporada)
            .then((result) => {
                setCodigoTemporada(temporada);
                const calendario = result.dado;
                if (calendario.length > 0) {
                    setShowRodadasTabs(true);
                    let rodadaAtual = -1;
                    let newlist: any[] = [];
                    let maxIndex = Math.max(...quantidadeRodada.map(m => m));
                    rodadaAtual = codigoRodada >= 0 ? codigoRodada : Number(quantidadeRodada.findIndex(i => i === maxIndex));
                    calendario.filter(y => codigoRodada >= 0 ? y.rodada === (codigoRodada + 1) : y.rodada_Atual).forEach((f) => {
                        newlist.push({
                            codigo: f.codigo,
                            rodada: f.rodada,
                            mandante: f.codigo_Franquia_Mandante,
                            visitante: f.codigo_Franquia_Visitante,
                            placarMandante: f.placar_Mandante,
                            placarVisitante: f.placar_Visitante,
                            mandanteVencedor: f.vencedor_Mandante,
                            visitanteVencedor: f.vencedor_Visitante,
                            empate: f.empate,
                            statusJogo: f.status_Jogo,
                            copinha: f.copinha
                        });
                    });

                    setValoresTimeSorteio(newlist);
                    setValueTabRodada(rodadaAtual);

                    setIsLoading(false);
                    setRemoveLoading(true);
                }
                else {

                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowRodadasTabs(false);
                    setValoresTimeSorteio([]);
                    setQtdRodadasEscolidas([]);
                }
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    };

    const handleChangeTabsRodadas = async (event: React.SyntheticEvent, newValue: number) => {
        setValueTabRodada(newValue);
        setIsLoading(true);
        setRemoveLoading(false);
        let val = qtdRodadasEscolidas.find((f, i) => newValue === i);
        await DisputaService.getCalendarioCopinhaPorRodada(Number(codigoLiga), codigoTemporada, Number(val))
            .then((result) => {
                setCodigoTemporada(codigoTemporada);
                const calendario = result.dado;
                if (calendario.length > 0) {
                    setShowRodadasTabs(true);
                    let rodadaAtual = 0;
                    let newlist: any[] = [];
                    calendario.filter(y => y.rodada === Number(val)).forEach(f => {
                        newlist.push({
                            codigo: f.codigo,
                            rodada: Number(val),
                            mandante: f.codigo_Franquia_Mandante,
                            visitante: f.codigo_Franquia_Visitante,
                            placarMandante: f.placar_Mandante,
                            placarVisitante: f.placar_Visitante,
                            mandanteVencedor: f.vencedor_Mandante,
                            visitanteVencedor: f.vencedor_Visitante,
                            empate: f.empate,
                            statusJogo: f.status_Jogo,
                            copinha: f.copinha
                        });
                    });

                    setValoresTimeSorteio(newlist);
                    if (Number(val) === 0) {
                        setValueTabRodada(rodadaAtual);
                    }
                    setIsLoading(false);
                    setRemoveLoading(true);
                }
                else {
                    setShowRodadasTabs(false);
                    setValoresTimeSorteio([]);
                    setQtdRodadasEscolidas([]);
                    setIsLoading(false);
                    setRemoveLoading(true);
                }

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });

    };

    const handleEscalacao = (codigoRodada: number, codigoJogo: number, codigoFranquia: number | undefined, minhaFranquia: boolean) => {
        let codigoTipoPosicao = dadosLiga !== undefined && dadosLiga.codigo_Tipo_Posicao_Confronto !== undefined ? dadosLiga.codigo_Tipo_Posicao_Confronto : 1;
        let resultadoCrypt = UtilidadeService.crypt(`${codigoRodada}/${codigoJogo}/${codigoFranquia}/${minhaFranquia}/${codigoTipoPosicao}/${codigoTemporada}/2`);
        setParametroCrypt(resultadoCrypt);
        //    navigate(`/escalacao/detalhe/${resultadoCrypt}`);
        if (dadosLiga?.codigo_Tipo_Pontuacao === 1) {
            navigate(`/escalacao/detalhe/${resultadoCrypt}`);
        }
        else {
            navigate(`/escalacao/pontuacao/detalhe/${resultadoCrypt}`);
        }
    }

    const handleRedirecionar = (codigo: number, rodada: number) => {
        if (codigo > 0) {
            let valores = `${codigo}/${codigoTemporada}/${rodada}/2`;
            let crypt = UtilidadeService.crypt(valores);
            if (dadosLiga?.codigo_Tipo_Pontuacao === 1) {
                navigate(`/liga/disputas/${crypt}`);
            }
            else {
                navigate(`/liga/disputas/pontuacao/${crypt}`);
            }
        }
    }

    return (
        <LayoutBaseDePagina
            titulo={`Calendário Copinha - ${dadosLiga?.nome}`}
            showLogoImg={dadosLiga?.caminho_Logo}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate(`/usuario/liga/${codLocal}`)}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2}>
                        <Grid size={{ xs: 12, sm: 12 }} >
                            <Typography variant="h6">Calendário Copinha</Typography>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial">
                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                    <Select
                                        variant="outlined"
                                        native={false}
                                        value={codigoTemporada}
                                        label="Temporadas"
                                        onChange={(e) => { handleSelectedTemporada(Number(e.target.value), rodadaAtual, qtdRodadas); }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }
                                    </Select>
                                </FormControl >
                            </Grid>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction="column"  >
                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2}>
                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                    <Typography variant="h6">Rodadas</Typography>
                                    <hr />
                                </Grid>
                            </Grid>
                            {!removeLoading && <Loading />}
                            {!showRodadasTabs ? (
                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                    <Typography variant="h6">Ainda não possui calendário para essa temporada! </Typography>
                                </Grid>
                            )
                                : (
                                    <Grid container size={{ xs: 12, sm: 12, md: 12 }} alignItems="center" justifyContent="center">
                                        <Paper sx={{ width: "100%" }}>
                                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                <Tabs value={valueTabRodada}
                                                    onChange={handleChangeTabsRodadas}
                                                    variant="scrollable"
                                                    scrollButtons
                                                    sx={{
                                                        [`& .${tabsClasses.scrollButtons}`]: {
                                                            '&.Mui-disabled': { opacity: 0.3 },
                                                        },
                                                    }}
                                                >
                                                    {showRodadasTabs && qtdRodadasEscolidas.map((t, i) => (
                                                        <Tab label={t} {...a11yProps(t)} />
                                                    ))
                                                    }
                                                </Tabs>
                                            </Box>
                                            {qtdRodadasEscolidas.map((q, i) => (
                                                <TabPanel key={i} value={valueTabRodada} index={i} >
                                                    <TableContainer component={Paper} variant="outlined" sx={{ width: "auto", }}>
                                                        <Table >
                                                            <TableHead>
                                                                <StyledTableRow key={`row ${q}`} >
                                                                    <StyledTableCell align="center" >{UtilidadeService.isMobile() ? "" : "ESCALAÇÃO"}</StyledTableCell>
                                                                    <StyledTableCell align="center" sx={{ display: UtilidadeService.isMobile() ? "none" : "auto" }} ></StyledTableCell>
                                                                    <StyledTableCell >{UtilidadeService.isMobile() ? "MAN" : "MANDANTE"}</StyledTableCell>
                                                                    <StyledTableCell align="center" style={{ fontSize: 10 }}>PLACAR</StyledTableCell>
                                                                    <StyledTableCell align="right" >{UtilidadeService.isMobile() ? "VIS" : "VISITANTE"}</StyledTableCell>
                                                                    <StyledTableCell align="center" sx={{ display: UtilidadeService.isMobile() ? "none" : "auto" }}></StyledTableCell>
                                                                    <StyledTableCell align="center" >{UtilidadeService.isMobile() ? "" : "ESCALAÇÃO"}</StyledTableCell>
                                                                    <StyledTableCell align="center" >{UtilidadeService.isMobile() ? "" : "COPINHA"}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableHead>
                                                            <TableBody >
                                                                {valoresTimeSorteio.filter((f) => f.rodada === q).map((row, index) => (
                                                                    <StyledTableRow key={row.rodada + index} >
                                                                        <StyledTableCell align="center" sx={{ ":hover": { backgroundColor: "#ce9e26" } }}>
                                                                            <IconButton size="small"
                                                                                onClick={() => handleEscalacao(row.rodada, row.codigo, row.mandante, minhaFranquia === row.mandante)}
                                                                            >
                                                                                {minhaFranquia > 0 && minhaFranquia === row.mandante ?
                                                                                    <Tooltip title="Escalar">
                                                                                        <Icon style={{ fontSize: UtilidadeService.isMobile() ? "1rem" : "1.5rem" }}>switch_account</Icon>
                                                                                    </Tooltip> :
                                                                                    <Tooltip title="Escalação" >
                                                                                        <Icon style={{ fontSize: UtilidadeService.isMobile() ? "1rem" : "1.5rem" }}>groups</Icon>
                                                                                    </Tooltip>}
                                                                            </IconButton>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell
                                                                            align="right"
                                                                            sx={{ display: UtilidadeService.isMobile() ? "none" : "auto", cursor: "pointer" }}
                                                                            onClick={() => handleRedirecionar(row.codigo, row.rodada)}
                                                                        >
                                                                            <img src={lstFranquia.find(l => l.codigo === row.mandante)?.descricao === null ? showImagemFranquia : lstFranquia.find(l => l.codigo === row.mandante)?.descricao} width={45} height={50} alt="logo" />
                                                                        </StyledTableCell>
                                                                        <StyledTableCell
                                                                            sx={{ cursor: "pointer" }}
                                                                            onClick={() => handleRedirecionar(row.codigo, row.rodada)}>

                                                                            &nbsp;&nbsp;
                                                                            <span style={{
                                                                                color: row.statusJogo && row.empate ? "#E46106"
                                                                                    : row.statusJogo && row.mandanteVencedor ? "#00e676"
                                                                                        : minhaFranquia > 0 && minhaFranquia === row.mandante ? "#4864E8"
                                                                                            : "auto", fontWeight: "bold"
                                                                            }}>
                                                                                {lstFranquia.find(l => l.codigo === row.mandante)?.label}
                                                                            </span></StyledTableCell>
                                                                        <StyledTableCell
                                                                            align="center"
                                                                            sx={{ cursor: "pointer", fontWeight: "bold" }}
                                                                            onClick={() => handleRedirecionar(row.codigo, row.rodada)}>
                                                                            {row.placarMandante}{`  X  `}{row.placarVisitante}
                                                                        </StyledTableCell>
                                                                        <StyledTableCell
                                                                            align="right"
                                                                            sx={{ cursor: "pointer" }}
                                                                            onClick={() => handleRedirecionar(row.codigo, row.rodada)}
                                                                        >
                                                                            <span style={{
                                                                                color: row.statusJogo && row.empate ? "#E46106"
                                                                                    : row.statusJogo && row.visitanteVencedor ? "#00e676"
                                                                                        : minhaFranquia > 0 && minhaFranquia === row.visitante ? "#4864E8"
                                                                                            : "auto",
                                                                                fontWeight: "bold",
                                                                            }}>
                                                                                {lstFranquia.find(l => l.codigo === row.visitante)?.label}
                                                                            </span>
                                                                            &nbsp;&nbsp;

                                                                        </StyledTableCell>
                                                                        <StyledTableCell
                                                                            align="right"
                                                                            sx={{ display: UtilidadeService.isMobile() ? "none" : "auto", cursor: "pointer" }}
                                                                            onClick={() => handleRedirecionar(row.codigo, row.rodada)}
                                                                        >
                                                                            <img src={lstFranquia.find(l => l.codigo === row.visitante)?.descricao === null ? showImagemFranquia : lstFranquia.find(l => l.codigo === row.visitante)?.descricao} width={45} height={50} alt="logo" />
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center" sx={{ ":hover": { backgroundColor: "#ce9e26" } }} >
                                                                            <IconButton size="small"
                                                                                onClick={() => handleEscalacao(row.rodada, row.codigo, row.visitante, minhaFranquia === row.visitante)}
                                                                            >
                                                                                {minhaFranquia > 0 && minhaFranquia === row.visitante ?
                                                                                    <Tooltip title="Escalar">
                                                                                        <Icon style={{ fontSize: UtilidadeService.isMobile() ? "1rem" : "1.5rem" }}>switch_account</Icon>
                                                                                    </Tooltip> :
                                                                                    <Tooltip title="Escalação" >
                                                                                        <Icon style={{ fontSize: UtilidadeService.isMobile() ? "1rem" : "1.5rem" }}>groups</Icon>
                                                                                    </Tooltip>}
                                                                            </IconButton>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell
                                                                            align="center"
                                                                        //sx={{ display: UtilidadeService.isMobile() ? "none" : "auto", cursor: "pointer" }}
                                                                        //onClick={() => handleRedirecionar(row.codigo, row.rodada)}
                                                                        >
                                                                            {row.copinha ? (
                                                                                <img src={themeName === "light" ? imgCoroa : imgCoroaWhite} style={{ color: "#ce9e26" }} width={themeName === "light" ? 30 : 35} height={themeName === "light" ? 30 : 25} alt="logo" />
                                                                            ) : "-"}
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </TabPanel>
                                            ))
                                            }
                                        </Paper>
                                    </Grid>
                                )}
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    )
};

